import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { textGray } from '../utils/colors';

const StyledBookSheet = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const StyledDivider = styled.div`
  width: 40%;

  @media all and (max-width: 700px) {
    width: 100%;
  }
`;

const StyledPartTitle = styled.p`
  font-size: 0.875rem;
  margin-bottom: 0;
  color: ${textGray};
  font-weight: 600;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const StyledSheetList = styled.ul`
  padding: 0;
  list-style: none;
  margin-top: 0.4rem;
`;

const StyledListElement = styled.li``;

const StyledAnchor = styled.a`
  color: ${textGray};
  text-decoration: none;
  font-size: 0.875rem;
  margin-top: 0.4rem;
  font-weight: 300;
  display: inline-block;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};

  &:hover,
  &:focus {
    font-weight: 600;
    color: ${props => props.theme.tertiary};
  }
`;

const BookSheet = ({ sheets, inverted }) => {
  return (
    <StyledBookSheet>
      {sheets.map((item, index) => {
        return (
          <StyledDivider key={index}>
            <StyledPartTitle inverted={inverted}>
              Del {item.part_data.title}
            </StyledPartTitle>
            <StyledSheetList>
              {item.sheet &&
                item.sheet.map((k, i) => {
                  return (
                    <StyledListElement key={i}>
                      <StyledAnchor href={k.url} download inverted={inverted}>
                        {k.title}
                      </StyledAnchor>
                    </StyledListElement>
                  );
                })}
            </StyledSheetList>
          </StyledDivider>
        );
      })}
    </StyledBookSheet>
  );
};

BookSheet.propTypes = {
  sheets: PropTypes.arrayOf(
    PropTypes.shape({
      part_data: PropTypes.shape({
        title: PropTypes.string.isRequired
      }).isRequired,
      sheet: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired
        })
      )
    })
  ),
  inverted: PropTypes.bool.isRequired
};

export default BookSheet;



// WEBPACK FOOTER //
// ./src/components/BookSheet.js